// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2gyDs","label":"Radio_label__fKMqd","checkMark":"Radio_checkMark__2pC_O","disabled":"Radio_disabled__15KRv"};